/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Min_Approvals_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum approvals" |
*
* @param {Iconik_Publish_Min_Approvals_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_min_approvals_label = /** @type {((inputs?: Iconik_Publish_Min_Approvals_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Min_Approvals_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Minimum approvals")
	if (locale === "de") return /** @type {LocalizedString} */ ("Minimum approvals")
	if (locale === "it") return /** @type {LocalizedString} */ ("Minimum approvals")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Minimum approvals")
	if (locale === "es") return /** @type {LocalizedString} */ ("Minimum approvals")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Minimum approvals")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Minimum approvals")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Minimum approvals")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Minimum approvals")
	return /** @type {LocalizedString} */ ("Minimum approvals")
});